import type { AxiosError } from 'axios';
import type { PaymentStatus } from './types';

export const formatVnd = (value: number | null | undefined) =>
  value === null || value === undefined ? '-' : `${new Intl.NumberFormat('vi-VN').format(value)} ₫`;

export const formatDateTime = (value?: string | null) =>
  value ? new Date(value).toLocaleString() : '-';

export const STATUS_COLOR: Record<
  PaymentStatus,
  'default' | 'success' | 'warning' | 'error' | 'info'
> = {
  PENDING: 'info',
  SUCCESS: 'success',
  NEEDS_REVIEW: 'warning',
  FAILED: 'error',
  EXPIRED: 'default',
  CANCELED: 'default',
  REFUNDED: 'default',
};

const REVIEW_TEXT: Record<string, string> = {
  paid_after_close: 'The customer paid after the order expired or was canceled.',
  amount_mismatch: 'The amount received does not match the order amount.',
  invoice_mismatch: 'The invoice number reported by the gateway does not match.',
};

export const reviewReason = (metadata: unknown): string | null => {
  if (!metadata || typeof metadata !== 'object') return null;
  const reason = (metadata as Record<string, unknown>).reviewReason;
  return typeof reason === 'string' ? (REVIEW_TEXT[reason] ?? reason) : null;
};

export const errorText = (error: unknown): string => {
  const body = (error as AxiosError<{ message?: string; error?: string }>).response?.data;
  return body?.message || body?.error || (error as Error).message || 'Request failed';
};

export const REASON_LABEL: Record<string, string> = {
  not_captured: 'The gateway has not captured the payment yet.',
  order_not_found: 'The gateway has no record of this order.',
  needs_review: 'The payment needs manual review.',
  state_changed: 'The order changed while reconciling.',
  missing_invoice: 'The order has no invoice number.',
};
